
import { useState, useCallback } from 'react';
import { Form, useActionData, useLocation } from 'react-router-dom';
import { Button, Input, Message } from 'semantic-ui-react';

import { PATHS } from '../../paths';
import { AuthCard } from '../../components/AuthCard';

import formStyles from '../../components/AuthCard/form.module.css';

function MobileLoginView() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const from = params.get('from') || PATHS.ROOT;

    const [attemptedLogin, setAttemptedLogin] = useState(false);
    const actionData = useActionData() as { error: string } | undefined;

    const setFailedTimer = useCallback(() => {
        setAttemptedLogin(false);
        const timer = setTimeout(() => setAttemptedLogin(true), 2000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <AuthCard title="Log in">
            {from.length > 1 && (
                <Message color='red' style={{ marginBottom: '1em' }}>
                    You must log in to view the page at {from}
                </Message>
            )}
            <Form method="post" replace>
                <input type="hidden" name="redirectTo" value={from} />
                <div className={formStyles.field}>
                    <Input
                        fluid
                        icon='user'
                        iconPosition='left'
                        placeholder='Username'
                        name='username'
                    />
                </div>
                <div className={formStyles.field}>
                    <Input
                        fluid
                        icon='lock'
                        iconPosition='left'
                        placeholder='Password'
                        name='password'
                        type='password'
                    />
                </div>
                {attemptedLogin && (
                    <Message error header='Login failed' content='Check your username and password and try again.' />
                )}
                {actionData?.error && (
                    <p className={formStyles.errorMsg}>{actionData.error}</p>
                )}
                <Button
                    type="submit"
                    fluid
                    size="large"
                    className={formStyles.submitBtn}
                    onClick={setFailedTimer}
                >
                    Log in
                </Button>
            </Form>
            <p className={formStyles.switchLink}>
                New to us? <a href={PATHS.SIGNUP}>Sign up</a>
            </p>
        </AuthCard>
    );
}

export { MobileLoginView };
